import { createActions, createReducer } from "reduxsauce"
import Immutable from "seamless-immutable"

const { Types, Creators } = createActions(
  {
    setGlobalFilters: ["filters"], // payload: { filters }
    addGlobalFilter: ["key", "value"], // payload: { key, value }
    removeGlobalFilter: ["key"], // payload: { key }
    clearGlobalFilters: null, // no payload
    logout: null
  },
  {}
)

export const GlobalFiltersTypes = Types
export default Creators

export const INITIAL_STATE = Immutable({
  filters: {
    user_email: []
  },
  testData: "false"
})

const setGlobalFilters = (state, { filters }) => {
  if (filters?.testData) {
    return state.merge({ testData: filters?.testData })
  }
  return state.merge({ filters })
}

const addGlobalFilter = (state, { key, value }) => {
  const currentValues = state.filters[key] || []

  if (!value || value.trim() === "") return state

  const updatedValues = currentValues.includes(value) ? currentValues : [...currentValues, value]

  const updatedFilters = { ...state.filters, [key]: updatedValues }
  return state.merge({ filters: updatedFilters })
}

const removeGlobalFilter = (state, { key }) => {
  const updatedFilters = { ...state.filters }
  delete updatedFilters[key]
  return state.merge({ filters: updatedFilters })
}

const clearGlobalFilters = (state) => state.merge({ filters: INITIAL_STATE.filters })

const logout = (state) =>
  state.merge({
    filters: INITIAL_STATE.filters
  })

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_GLOBAL_FILTERS]: setGlobalFilters,
  [Types.ADD_GLOBAL_FILTER]: addGlobalFilter,
  [Types.REMOVE_GLOBAL_FILTER]: removeGlobalFilter,
  [Types.CLEAR_GLOBAL_FILTERS]: clearGlobalFilters,
  [Types.LOGOUT]: logout
})
